import { Component, OnInit } from '@angular/core';
import { RightsTemplate } from 'src/app/models/rightsTemplate';
import { UserService } from 'src/app/shared/user/user-service.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-rights-template',
  templateUrl: './rights-template.component.html',
  styleUrls: ['./rights-template.component.css']
})
export class RightsTemplateComponent implements OnInit {

  rights: RightsTemplate[];
  selectedValue =  new FormControl(this.rights);
  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.getRights();
  }

  getRights(): void {
    this.userService.getRightsTemplate().subscribe((rights => this.rights = rights) );
  }
  onChange(event) {
    console.log(event);
  }
}
